import "./index.scss";
import generateConfig from './controller';
import { insertDocument } from '../../../common/utils';


const downloadAppHtml = function (config) {
  return `
  <div id="force-download-app" class="force-download-app">
    <div class="dialog-mask"></div>
    <div class="dialog-container">
      <div class="dialog-title" role="title-text">${config.titleContent}</div>
      <div class="dialog-buttons">
        <div id="force-download" data-ck="${config.ck}" data-page="${config.page}" data-schema-params="${config.pageSchema}" class="new-download-app download-button">${config.viewInAppButton}</div>
        <div id="force-cancel" data-ck="${config.ck}" data-cancel="true" class="new-download-app cancel-button">${config.cancelButton}</div>
      </div>
    </div>
  </div>
`
}

function DownloadApp () {

  if (!window.__downloadApp) return;
  const i18n = window.__downloadApp.force.i18n;
  this.defauleConfig = {
    id: 'force-download-app-wrap',
    ck: 'wap_force_dialog',
    page: 'home',
    pageSchema: '',
    needShow: false,
    cancelButton: i18n.cancel || 'Cancel',
    viewInAppButton: i18n.open || 'Open',
    titleContent: i18n.title || 'Continue in Alibaba.com App',
  };
  this.config = {};
  this.showState = false;

  this.init = () => {
    
    // 根据页面传递配置，显示不同的数据
    this.config = generateConfig(this.defauleConfig);

    // 如果页面中已经存在，则不再继续渲染
    if (document.getElementById(this.config.id)) return;

    // 实例化dom结构
    const DomFragment = downloadAppHtml(this.config);
    insertDocument(DomFragment, this.config.id);
    
    // console.log(this.config.needShow)
    // 判断是否需要显示引流框
    if (this.config.needShow) {
      this.show();
    }

    // 监听关闭事件
    document.getElementById('force-cancel').addEventListener('click', (e) => {
      this.hide();
    })
  }
  this.hide = () => {
    const ele = document.getElementById(this.config.id);
    if (!this.showState || !ele) return;
    this.showState = false;
    document.getElementById(this.config.id).className = `${this.config.id} close`;
    // 300ms后自动清空dom
    setTimeout(() => {
      ele.parentNode.removeChild(ele);
    }, 300)
  }
  this.show = () => {
    const ele = document.getElementById(this.config.id);
    if (this.showState || !ele) return;
    this.showState = true;
    document.getElementById(this.config.id).className = `${this.config.id} show`;
    this.dot();
  }
  this.handlerPageConfig = () => {
    
  }
  // 后面增加曝光功能后，会全部下掉
  this.dot = () => {
     // 为了兼容现有的全站统一的引流打点规范，先暂时做的hack
    window.addEventListener('load', function () {
      window.goldlog && window.goldlog.record('/sc.mobile.download-app','CLK',`action=expose&ck=wap_force_dialog&pageid=${window.dmtrack_pageid}&spm=${goldlog.spm_ab.length ? goldlog.spm_ab.join('.') : ''}`,'GET')
    })
  }
  // 初始化的时候自动调用init
  this.init()
}


// 初始化
export default DownloadApp;



// WEBPACK FOOTER //
// ./src/modules/download-app/force/index.js